import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Button from "components/Button";

const StyledButton = styled(Button)`
  filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.25));
  left: 0;
  margin: auto;
  position: absolute;
  top: 0.625rem;
  right: 0;
  width: 11.75rem;
  z-index: 2;
`;

const SearchAreaButton = ({ map, router, services }) => {
  const handleSearchArea = () => {
    const bounds = map.getBounds();
    const center = map.getCenter();

    const southWest = bounds.getSouthWest();
    const northEast = bounds.getNorthEast();

    // Get lon distance from center
    const lngRad = (northEast.lng() - southWest.lng()) / 2;

    // Get lat distance from center
    const latRad = (northEast.lat() - southWest.lat()) / 2;

    // See which is shorter
    const shortDist = Math.min(latRad, lngRad);

    // Convert to miles (69.2 mi/deg)
    const radius = shortDist * 69.2;

    router.push({
      query: {
        currentPage: 1,
        formattedAddress: "Current Map Area",
        latitude: center.lat(),
        longitude: center.lng(),
        s: services,
        radius,
      },
    });
  };

  return (
    <StyledButton outlineType="outline" outlineTransparent={false} onClick={handleSearchArea}>
      Search this area
    </StyledButton>
  );
};

export default SearchAreaButton;

SearchAreaButton.propTypes = {
  map: PropTypes.shape({
    getBounds: () => {},
    getCenter: () => {},
  }).isRequired,
  router: PropTypes.shape({
    push: () => {},
  }).isRequired,
  services: PropTypes.string,
};

SearchAreaButton.defaultProps = {
  services: "all",
};
